module.exports = __webpack_public_path__ + "img/IT0004082678137.904d8a85.png";